export default "__VITE_ASSET__CIU$K1MA__"